import { Link } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import defaultImage from "../assets/img/logo.png";
import { productImageUrl, rememberMissingImage, hasKnownMissingImage } from "../utils/productImage";


const ProductCard = ({ product, showPrice }) => {

	// Si ya sabemos que este SKU no tiene foto, arrancamos con el placeholder y
	// nos ahorramos el 404 (y el parpadeo) en cada render y en cada navegación.
	const [imageSrc, setImageSrc] = useState(
		() => hasKnownMissingImage(product.sku) ? defaultImage : productImageUrl(product.sku)
	);
	const imageRef = useRef(null);

	const handleImageError = () => {
		rememberMissingImage(product.sku);
		setImageSrc(defaultImage);
	};

	// El HTML estático empieza a cargar la foto antes de hidratar, así que el
	// `onError` puede perderse: al montar revisamos si ya falló.
	useEffect(() => {
		const image = imageRef.current;
		if (image && image.complete && image.naturalWidth === 0) handleImageError();
	}, []);

	return (
		<Link to={"/products/" + product.slug } className="group">
			<article className="flex h-72 flex-col items-center justify-between border border-line bg-white px-6 py-5 transition-all duration-300 group-hover:border-line-strong group-hover:shadow-card">
				<img
					ref={ imageRef }
					className="h-40 w-40 object-contain"
					src={ imageSrc }
					onError={ handleImageError }
					alt={ product.name }
					width="160"
					height="160"
					loading="lazy"
					decoding="async"
				/>

				<div className="mt-3 w-full text-center">
					<small className="text-[10px] font-semibold uppercase tracking-[.065em] text-muted">{ product.sku }</small>
					<h2 className="mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm text-ink-soft group-hover:whitespace-normal">
						{ product.name }
					</h2>
					{
						showPrice &&
							<p className="mt-1.5 overflow-hidden text-ellipsis whitespace-nowrap text-base font-bold tracking-[-.02em]">
								{
									product.price === 0 ? "AGOTADO" : "$ " + product.price
								}
							</p>
					}
				</div>
			</article>
		</Link>
	);
};

export default ProductCard;
